import {
  FETCH_USER_SUCCESS,
  USER_LOGOUT,
  USER_LOGIN,
  SET_ACCOUNT_NOT_SETUP,
} from './userActionType';
import axios from 'axios';
import { alertAction } from '../Alert/alertActions';
import { loaderAction } from '../loader/loaderActions';
import { Dispatch } from 'redux';
import secureLocalStorage from 'react-secure-storage';
export const fetchUserSuccess = (USER: any): any => {
  return {
    type: FETCH_USER_SUCCESS,
    payload: USER,
  };
};

export const setAccountNotSetup = (userInfo: any): any => ({
  type: SET_ACCOUNT_NOT_SETUP,
  payload: userInfo,
});

const userLogout = (): any => {
  return {
    type: USER_LOGOUT,
  };
};
const userLogin = (): any => {
  return {
    type: USER_LOGIN,
  };
};

export const fetchUser = (cognitoUserInfo?: any): any => {

  return async function (dispatch: Dispatch) {
    dispatch(loaderAction(true) as any);

    // FOR TESTING - COMMENT BEFORE COMMIT
    // dispatch(loaderAction(false) as any);
    // dispatch(setAccountNotSetup(cognitoUserInfo || {}));
    // return;
    // END 

    await axios
      .get(`${import.meta.env.VITE_BACKEND}api/Users/profile`, {
        withCredentials: false,
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (!response?.data?.Email) {
          dispatch(loaderAction(false) as any);
          dispatch(alertAction('Can not find any user for this Username and Password', true, 'error') as any);
        } else {
          const USER = response.data;
          dispatch(fetchUserSuccess(USER));
          dispatch(loaderAction(false) as any);
        }
      })
      .catch((error) => {
          dispatch(loaderAction(false) as any);
          const status = error.response?.status;
          const message = error.response?.data?.Message || '';
          if (status === 404) {
            if (message.includes('affiliates') || message.toLowerCase().includes('affiliate')) {
              // Scenario 3: User exists but has no affiliates — log them in with empty affiliates
              dispatch(fetchUserSuccess({ Email: cognitoUserInfo?.email || '', Name: '', Affiliates: [], IsAdmin: 0 }));
            } else {
              // Scenario 1/2: User has no portal account at all
              dispatch(setAccountNotSetup(cognitoUserInfo || {}));
            }
          } else {
            dispatch(alertAction('Failed to load user profile. Please try again.', true, 'error') as any);
          }
      });
  };
};


export const logout = (): any => {
  secureLocalStorage.clear();
  window.location.href = window.location.origin;
  return function (dispatch: Dispatch) {
    dispatch(userLogout());
  };
};

export const login = () => {
  return function (dispatch: Dispatch) {
    dispatch(userLogin());
  };
};